import React from "react";
import { awardsBanner } from "constants/bannerDetails";
// import FadeUp from "components/FadeUp";
import "./awardsPage.scss";
// import AwardCard from "components/AwardCard/index";
// import { awardCardData } from "components/AwardCard/awardCardData";
import ADICard from "components/ADICard/index";
import NearBy from "components/NearBy/index";
import AwardsBanner from "components/AwardsBanner";
import WorldSpiritsCard from "components/WorldSpiritsCard/index";
// import ScoresCard from "components/ScoresCard/index";
import FeedbackSection from "components/FeedbackSection/index";
import BannerDivider from "components/BannerDivider";

const AwardsPage = () => {
  return (
    <>
      <AwardsBanner
        desktopBannerImage={awardsBanner?.desktopBannerImage}
        tabBannerImage={awardsBanner?.tabBannerImage}
        mobileBannerImage={awardsBanner?.mobileBannerImage}
        heading={awardsBanner?.heading}
        paragraph={awardsBanner?.paragraph}
      />

      <BannerDivider text="Tharra Company's dedication to crafting exceptional spirits has been acknowledged by prestigious international competitions. We are honored to receive these awards, which reflect our passion for quality ingredients and authentic Indian flavors." />

      <div className="awardsPageContainer">
        <div className="awardsSection">
          <div className="awardSectionContent">
            <span className="awardSectionTitle">Our Prestigious Awards</span>
            <span className="awardSectionDescription">
              Our spirits have been honored at two highly respected
              competitions:
            </span>
          </div>
          <div className="awardCards">
            <ADICard title="Gold Medal Awards" />
            <WorldSpiritsCard title="World Spirits Competition" />
          </div>
        </div>
        <div className="feedbacksection">
          <FeedbackSection />
        </div>
      </div>

      <NearBy />
    </>
  );
};

export default AwardsPage;
